import { Component, OnInit } from '@angular/core';
import { OperadoresService } from '../operadores.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
  private operadores;

  constructor() { }

   ngOnInit() {
  
  }

}
